// extracted by mini-css-extract-plugin
export const txtTitle = "D_d";
export const txtSubTitle = "D_f";
export const loginAppIcon = "D_b";
export const form = "D_t";